<template>
  <a-row v-if="show">
    <div class="pagination" style="font-weight: normal; float: right; margin-bottom: 20px;">
      <span> Total {{ meta.total }} {{ label }} </span>
      <span style="margin-left: 5px; margin-right: 5px; color: #cecece"> | </span>
      <span> Page {{ meta.current_page }} of {{ meta.last_page }}</span>
      <span style="margin-left: 5px; margin-right: 5px; color: #cecece"> | </span>
      <a :disabled="meta.current_page == 1"
         style="margin-right: 10px;"
         class="pagination--btn"
         @click.prevent="paginate(meta.current_page - 1)"
         v-if="meta.last_page > 1"
      >&lt; Previous</a>
      <a
          :disabled="meta.current_page == meta.last_page"
          class="pagination--btn"
          @click.prevent="paginate(meta.current_page + 1)"
          v-if="meta.last_page > 1"
      >Next &gt;</a>
    </div>
  </a-row>
</template>

<script>
  export default {
    props: {
      show: {
        type: Boolean,
        required: false,
        default: true
      },

      meta: {
        type: Object,
        required: true
      },

      label: {
        type: String,
        required: true
      }
    }, // props

    methods: {
      paginate( value ) {
        this.$emit( 'change', value );
      }
    } // methods
  }
</script>
<style scoped>
@media (min-width: 768px) {
  .align-md-right {
    text-align: right;
  }
}

.pagination--btn {
  background-color: #e5e5e5;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 5px 9px;
  line-height: 1.8;
}
</style>
